module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="detail_recaphisto_sp">\r\n\r\n</span>';
}
return __p;
};
